import { DEMO_BBOX_OGC } from '../config/map.js';

const BGT_BASE = 'https://api.pdok.nl/lv/bgt/ogc/v1_0';
const MAX_ITEMS = 1000;

export async function fetchWaterdeel() {
  const features = [];
  const params = new URLSearchParams({
    bbox: DEMO_BBOX_OGC,
    limit: MAX_ITEMS.toString(),
    f: 'json',
  });

  let url = `${BGT_BASE}/collections/waterdeel/items?${params}`;

  while (url) {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`BGT request failed: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();

    if (data.features && data.features.length > 0) {
      features.push(...data.features);
    }

    const nextLink = data.links?.find((l) => l.rel === 'next');
    url = nextLink?.href || null;
  }

  return {
    type: 'FeatureCollection',
    features,
  };
}
